<div class="box-menu-settings active box-menu-settings-wrapper">
	<div class="box-menu-settings active" [class.top-padding]="isResetAnalysisWarning()">

		@if (isResetAnalysisWarning()) {
		<div data-testid="SUBSYS2_CATEGORIZATION_RESET_WARNING_LBL" class="alert alert-warning reset-warning">
			<i class="material-icons md-18 me-3">report_problem</i>
			{{ labels().IMAGE_GARAGE_COMPONENT_RESET_ANALYSIS_WARNING }}
		</div>
		}

		<div class="row-box">
			<h4 data-testid="SUBSYS2_IMAGEEDIT_TITLE_TXT">{{ this.labels().IMAGE_EDIT_COMPONENT_TITLE_ROTATE }}</h4>
		</div>
		<div class="row-box">
			<div class="box-suggestion mb-0">
				<p data-testid="SUBSYS2_IMAGEEDIT_TOOLINFO_TXT">{{ this.labels().IMAGE_EDIT_COMPONENT_MESSAGE_ROTATE }}</p>
			</div>
		</div>
		<div class="row-box wrapper-img-axis justify-content-center">
			<div class="" [hidden]="!isImgVisible">
				<img data-testid="SUBSYS2_IMAGEEDIT_HELP_IMG" [src]="'images/gif/rotate.gif'" alt="edit tool"
					(load)='isImgVisible = true'>
			</div>
		</div>

		<div class="bottom-margin"></div>
		<div class="container-btn-confirm">
			<div class="divider-box"></div>
			<div class="wrapper-btn-confirm">
				<button data-testid="SUBSYS2_IMAGEEDIT_CONFIRM_BTN" type="button" class="btn btn-primary px-2"
					(click)="confirm()">
					{{ labels().IMAGE_EDIT_COMPONENT_CONFIRM_BTN }}
				</button>
			</div>
		</div>

	</div>
</div>